import { render, staticRenderFns } from "./TicketsBoard.vue?vue&type=template&id=ade2ac0c&scoped=true"
import script from "./TicketsBoard.vue?vue&type=script&lang=js"
export * from "./TicketsBoard.vue?vue&type=script&lang=js"
import style0 from "./TicketsBoard.vue?vue&type=style&index=0&id=ade2ac0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade2ac0c",
  null
  
)

export default component.exports